import {
  Button,
  Col,
  Dropdown,
  Input,
  Menu,
  PageHeader,
  Row,
  Space,
  Spin,
  Statistic,
  Table,
  Tag
} from "antd";
import { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { DELETE, GET, UPDATE } from "../constants/request-type";
import {
  country,
  delete_country,
  get_all_country,
  update_country
} from "../constants/routes";
import { service_api } from "../constants/url";
import Country_edit from "../forms/country_edit";
import Country_new from "../forms/country_new";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";
import { openNotificationWithIcon } from "../functions/notification";

import logger from "../../utils/logger.js";
const token = sessionStorage.getItem("auth_token");

class CountryCountry extends Component {
  state = {
    selectedRowKeys: [],
    searchText: "",
    searchedColumn: "",
    load: true,
    data: [],
    overall: true,
    allowed: false,
    blocked: false
  };

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    const request_details = {
      type: GET,
      url: service_api,
      route: country + "/" + get_all_country,
      data: null,
      token: token
    };
    try {
      const response = await MakeRequestAsync(request_details);
      this.setState({
        load: false,
        data: decryptSingleData(response.data.country)
      });
    } catch (err) {
      this.setState({ load: false });
      return openNotificationWithIcon("error", `${err.response.data.message}`);
    }
  };

  onSelectChange = (selectedRowKeys) => {
    logger.log("selectedRowKeys changed: ", selectedRowKeys);
    this.setState({ selectedRowKeys });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      )
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  handleStatus = async (id, status) => {
    const data = {
      status: status
    };
    const request_details = {
      type: UPDATE,
      url: service_api,
      route: country + "/" + update_country + "/" + id,
      data: data,
      token: token
    };
    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      return openNotificationWithIcon("error", `${err.response.data}`);
    }
  };

  handleDelete = async (id) => {
    const request_details = {
      type: DELETE,
      url: service_api,
      route: country + "/" + delete_country + "/" + id,
      token: token
    };
    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      return openNotificationWithIcon("error", `${err.response.data}`);
    }
  };

  render() {
    const columns = [
      {
        title: "Id",
        dataIndex: "_id",

        ...this.getColumnSearchProps("_id"),
        fixed: "left"
      },
      {
        title: "Pays",
        dataIndex: "country",

        render: (text) => (
          <Tag color="blue">
            <b>{text?.country_name}</b>
          </Tag>
        )
      },
      {
        title: "Code",
        dataIndex: "country",

        render: (text) => (
          <Tag color="blue">
            <b>{text?.country_code}</b>
          </Tag>
        )
      },
      {
        title: "Drapeau",
        dataIndex: "country",

        render: (text) => (
          <img
            src={text.flag}
            style={{
              width: 40,
              height: 25
            }}
          />
        )
      },
      {
        title: "Logo Pani",
        dataIndex: "general",

        render: (text) => (
          <img
            src={text.logo}
            style={{
              width: 40,
              height: 40
            }}
          />
        )
      },

      {
        title: "Actif",
        dataIndex: "status",
        ...this.getColumnSearchProps("status"),
        render: (text) =>
          text === true ? (
            <Tag color={"green"} key={text}>
              OUI
            </Tag>
          ) : (
            <Tag color={"volcano"} key={text}>
              NON
            </Tag>
          )
      },
      {
        title: "Création",
        dataIndex: "createdAt",
        render: (text) => <Tag>{text?.slice(0, 16)}</Tag>
      },
      {
        title: "Actions",
        fixed: "right",
        render: (text, record) => (
          <div>
            <Dropdown
              overlay={MenuButton(record)}
              placement="bottomCenter"
              arrow
            >
              <Button>Options</Button>
            </Dropdown>
          </div>
        )
      }
    ];

    const MenuButton = (record) => (
      <Menu>
        <Menu.Item>
          <Country_edit row={record} />
        </Menu.Item>
        {record.status === true ? (
          <Menu.Item>
            <Link onClick={() => this.handleStatus(record._id, false)}>
              Desactiver
            </Link>
          </Menu.Item>
        ) : (
          <Menu.Item>
            <Link onClick={() => this.handleStatus(record._id, true)}>
              Activer
            </Link>
          </Menu.Item>
        )}
        <Menu.Item>
          <Link onClick={() => this.handleDelete(record._id)}>Supprimé</Link>
        </Menu.Item>
      </Menu>
    );
    const { load, data } = this.state;
    return (
      <>
        <PageHeader
          title="Pays"
          tags={<Tag color="blue">Liste des pays</Tag>}
          subTitle=""
          extra={[
            // <Driver_country_new />
            <Country_new />
          ]}
        >
          <Row>
            <Statistic title="Total" value={data.length} style={{}} />

            <Statistic
              title="Inactif"
              value={data.filter((item) => item.status === false).length}
              style={{
                margin: "0 32px"
              }}
            />
            <Statistic
              title="Actif"
              value={data.filter((item) => item.status === true).length}
            />
          </Row>
          <Row>
            {load ? (
              <Space size="middle">
                <Spin size="large" />
              </Space>
            ) : (
              <Col span={24}>
                <Table columns={columns} dataSource={data} />
              </Col>
            )}
          </Row>
        </PageHeader>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    admin: state.admin
  };
};

const mapDispatchStoreToProps = () => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchStoreToProps
)(CountryCountry);
